module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionPermission.user.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionPermission.user)))])], 1), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionPermission)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": _vm.isMissionCreatorPermission
    },
    on: {
      "click": _vm.deleteMissionPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f43c5f84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionPermissionsRow.vue
// module id = 578
// module chunks = 0